import { ExportToCsv } from 'export-to-csv'


  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    title: 'CSV Export',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
  };

function convertToListOfDicts(mydata) {
  let allkeys = Object.keys(mydata)
  let fullLength = mydata[allkeys[0]].length
  let output = []
  for (let i=0;i<fullLength;i++) {
    let row = {}
    for (let k in allkeys) {
      row[allkeys[k]] = mydata[allkeys[k]][i]
    }
    output.push(row)
  }
  return output
}


function exportCSVFromDicts(mydata) {
  let cleandata = convertToListOfDicts(mydata)
  exportCSV(cleandata)
}

function exportCSV(data) {
  const csvExporter = new ExportToCsv(options)
  csvExporter.generateCsv(data)
}

function exportNamedCSVFromDicts(mydata,name) {
    let cleandata = convertToListOfDicts(mydata)
    let options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        title: 'CSV Export',
        filename: 'CSV Export',
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
    };
    if(name&&name!==""){
        options.filename = name
    }
    const csvExporter = new ExportToCsv(options)
    csvExporter.generateCsv(cleandata)
}

export {exportCSV, exportCSVFromDicts,exportNamedCSVFromDicts}
